import { atom, useAtom } from "jotai";
import { isOpenContactDrawer, isUnitContactDrawer } from "state/store.global";

// const isOpenContactDrawer = atom(false);
// const contactDrawerUnit = atom(null);

const useContactDrawer = () => {
  const [isOpen, setIsOpen] = useAtom(isOpenContactDrawer);
  const [unit, setUnit] = useAtom(isUnitContactDrawer);

  const toggle = () => {
    if (isOpen) {
      // set null if closed.
      setUnit(null);
    }

    setIsOpen(!isOpen);
  };

  const open = unit => {
    setUnit(unit);
    setIsOpen(true);
  };

  return { toggle, open, isOpen, unit };
};

export { useContactDrawer };
